export default __webpack_public_path__ + "static/tommy-f006e071b7a14a32822fdccba08e7749.png";